var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 26,
    viewBox: "0 0 143 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3775 25.9995C48.967 25.9995 47.5565 25.9995 46.0375 25.9995C46.0375 23.245 46.0375 20.4906 46.0375 17.7016C44.5547 17.7016 43.1804 17.7016 41.6614 17.7016C41.6614 16.29 41.6614 14.9471 41.6614 13.5355C40.1786 13.5355 38.7681 13.5355 37.3214 13.5355C37.3214 17.6672 37.3214 21.7989 37.3214 25.9651C35.8386 25.9651 34.392 25.9651 32.9453 25.9651C32.9453 19.0444 32.9453 12.1238 32.9453 5.20312C34.392 5.20312 35.8025 5.20312 37.2853 5.20312C37.2853 6.58037 37.2853 7.92319 37.2853 9.30043C38.7681 9.30043 40.1424 9.30043 41.6252 9.30043C41.6252 10.7121 41.6252 12.0894 41.6252 13.4666C43.1081 13.4666 44.5185 13.4666 45.9652 13.4666C45.9652 10.7121 45.9652 7.99205 45.9652 5.20312C47.448 5.20312 48.8585 5.20312 50.3413 5.20312C50.3775 12.1238 50.3775 19.0444 50.3775 25.9995Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.987 26.0003C101.987 19.0452 101.987 12.1589 101.987 5.23828C106.327 5.23828 110.667 5.23828 115.043 5.23828C115.043 12.1589 115.043 19.0796 115.043 26.0003C110.703 26.0003 106.363 26.0003 101.987 26.0003ZM106.4 9.37002C106.4 13.5362 106.4 17.6679 106.4 21.7997C107.846 21.7997 109.257 21.7997 110.667 21.7997C110.667 17.6335 110.667 13.5018 110.667 9.37002C109.221 9.37002 107.846 9.37002 106.4 9.37002Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7776 17.7016C12.2587 17.7016 10.8843 17.7016 9.43769 17.7016C9.43769 20.4561 9.43769 23.1762 9.43769 25.9651C7.9187 25.9651 6.50821 25.9651 5.02539 25.9651C5.02539 20.3873 5.02539 14.8094 5.02539 9.19714C6.43588 9.19714 7.8102 9.19714 9.25685 9.19714C9.25685 7.85432 9.25685 6.54594 9.25685 5.20312C12.2225 5.20312 15.152 5.20312 18.1176 5.20312C18.1176 12.1238 18.1176 19.0444 18.1176 25.9651C16.7071 25.9651 15.2966 25.9651 13.8138 25.9651C13.7776 23.245 13.7776 20.525 13.7776 17.7016ZM13.7053 9.40373C12.2587 9.40373 10.8482 9.40373 9.43769 9.40373C9.43769 10.8154 9.43769 12.1582 9.43769 13.501C10.8843 13.501 12.2948 13.501 13.7053 13.501C13.7053 12.1238 13.7053 10.7465 13.7053 9.40373Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.944 5.20312C131.427 5.20312 132.837 5.20312 134.32 5.20312C134.32 10.7465 134.32 16.2555 134.32 21.8334C137.213 21.8334 140.07 21.8334 143 21.8334C143 23.245 143 24.5879 143 25.9995C138.66 25.9995 134.32 25.9995 129.98 25.9995C129.944 19.0444 129.944 12.1582 129.944 5.20312Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9944 13.501C72.5839 13.501 71.1372 13.501 69.6544 13.501C69.6544 17.7016 69.6544 21.8334 69.6544 25.9651C68.1716 25.9651 66.7611 25.9651 65.3145 25.9651C65.3145 19.0444 65.3145 12.1238 65.3145 5.20312C66.7249 5.20312 68.1716 5.20312 69.6544 5.20312C69.6544 6.54594 69.6544 7.92319 69.6544 9.30043C71.1372 9.30043 72.5116 9.30043 73.9944 9.30043C73.9944 10.7465 73.9944 12.1582 73.9944 13.501Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4429 13.5357C78.4429 12.1585 78.4429 10.7812 78.4429 9.33511C79.8534 9.33511 81.2638 9.33511 82.7467 9.33511C82.7467 7.92344 82.7467 6.58062 82.7467 5.16895C84.2295 5.16895 85.6038 5.16895 87.0505 5.16895C87.0505 12.0896 87.0505 19.0103 87.0505 25.9654C85.64 25.9654 84.2657 25.9654 82.7467 25.9654C82.7467 21.8336 82.7467 17.7019 82.7467 13.5013C81.2638 13.5357 79.8534 13.5357 78.4429 13.5357Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4756_439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.52079 3C7.52079 4.41168 7.52079 5.82335 7.52079 7.26946C6.00181 7.26946 4.51899 7.26946 3 7.26946C3 5.85779 3 4.44611 3 3C4.48282 3 5.96564 3 7.52079 3Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9946 13.5358C75.4774 13.5358 76.9603 13.5358 78.4431 13.5358C78.4431 14.9131 78.4431 16.2559 78.4431 17.6675C76.9603 17.6675 75.5136 17.6675 73.9946 17.6675C73.9946 16.2903 73.9946 14.9131 73.9946 13.5358C73.9946 13.5358 73.9946 13.5014 73.9946 13.5358Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4756_439",
    x: 0,
    y: 0,
    width: 10.521,
    height: 10.2695,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4756_439"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4756_439",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter);
export default __webpack_public_path__ + "static/media/Logo_footer.75146ef105bc674f79c353c6447f0087.svg";
export { ForwardRef as ReactComponent };